let initialState = {
	isSplitPanelVisible: false,
};
const Split = (state = initialState, action) => {
	switch (action.type) {
		case "SET_SPLIT_PANEL_VISIBLE":
			return {
				...state,
				isSplitPanelVisible: action.payload,
			};

		default:
			return state;
	}
};

export default Split;
